import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'

const CARD_TRIGGER_CLASS_NAME =
  'block h-full w-full rounded-md bg-transparent text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'

export const CardClickTarget = forwardRef<
  HTMLButtonElement,
  {
    children: ReactNode
  } & Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'disabled' | 'onClick'>
>(({ children, ...props }, ref) => (
  <button ref={ref} type="button" className={CARD_TRIGGER_CLASS_NAME} {...props}>
    {children}
  </button>
))

CardClickTarget.displayName = 'CardClickTarget'
